export default __webpack_public_path__ + "static/media/SWT0700.34I-20613_-22449_0.cbaf122e.jpg";